export const toggleDot = (nav, index) => {
  const dots = Array.from(nav.children);
  dots.forEach((dot) => {
    dot.classList.remove("active");
    const button = dot.querySelector("button")
    if (button) {
      button.removeAttribute("aria-current");
    }
  });
  const normalizedIndex = index < 0 ? 0 : index >= dots.length ? dots.length - 1 : index;
  const dot = dots[normalizedIndex];
  if (dot) {
    dot.classList.add("active");
    const button = dot.querySelector("button")
    if (button) {
      button.setAttribute("aria-current", "true");
    }
  }
};
